import { isNull } from 'utils/tsHelpers';
import { useCallback } from 'react';
import { ElementType, useIndex } from '../../../contexts/elementIndex';
import { useFieldArray } from '../../../contexts';
import { useClauseConditionsFieldPath } from '../fieldPaths/useClauseConditionsFieldPath';

export const useRemoveCondition = () => {
  const index = useIndex(ElementType.condition);
  if (isNull(index)) {
    throw new Error('Cannot delete condition: no condition index found in context');
  }
  const fieldPath = useClauseConditionsFieldPath();
  const { remove } = useFieldArray({ name: fieldPath });
  return useCallback(() => remove(index), [remove, index]);
};
